
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-po-box",
      function () {
        return require("private-next-pages/virtual-po-box.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-po-box"])
      });
    }
  